import { render } from "./PageLoader.vue?vue&type=template&id=450fa0b2&scoped=true"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=450fa0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450fa0b2"],['__file',"src/components/PageLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "450fa0b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('450fa0b2', __exports__)) {
    api.reload('450fa0b2', __exports__)
  }
  
  module.hot.accept("./PageLoader.vue?vue&type=template&id=450fa0b2&scoped=true", () => {
    api.rerender('450fa0b2', render)
  })

}


export default __exports__